export function* tryApiCall(name, defaultValue, apiCall) {
  try {
    const { data } = yield apiCall
    return data
  } catch (error) {
    console.info(`Failed to get ${name}, ignoring`, error)
    return defaultValue
  }
}



// WEBPACK FOOTER //
// ../source/utilities/sagas.js